import { render, staticRenderFns } from "./SafetyEquipmentCreate.vue?vue&type=template&id=6ba679a4&scoped=true"
import script from "./SafetyEquipmentCreate.vue?vue&type=script&lang=js"
export * from "./SafetyEquipmentCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba679a4",
  null
  
)

export default component.exports